import { Injectable, } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class QuickLinkService {
  private closeSubject = new Subject<void>();
  onClose$ = this.closeSubject.asObservable();

  triggerClose() {
    this.closeSubject.next();
  }
}
